export default "__VITE_ASSET__DUG3HrCd__"